import React from 'react'

import { CardContent, useTheme } from '@mui/material'
import Card from '@mui/material/Card'

import Button from '@/components/Common/Button'
import Link from '@/components/Common/Link'

import getRoutes from '@/lib/getRoutes'
import pushRoute from '@/lib/pushRoute'
import { getDomainSetting } from '@/lib/getDomainSettings'

const InviteBox: React.FC = () => {
  const theme = useTheme()

  const urlLogin = getRoutes({ route: 'LoginRedirect' })

  return (
    <Card
      style={{
        background: theme.palette.primary.main,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      }}
    >
      <CardContent>
        <div className="flex justify-between items-center text-white">
          <div>
            <div className="text-xl font-extrabold uppercase tracking-wide">
              {t({ id: 'web_invitebox_pharmacien' })}
            </div>
            <div className="text-base font-bold">
              {t({ id: 'web_invitebox_nouveau_client' })}{' '}
              <Link href={`${getDomainSetting('urlExtranetGroup')}inscription?type=pharmacy`}>
                <span
                  className="text-white underline lowercase hover:text-gray-500"
                  style={{ '--tw-text-opacity': 1 } as React.CSSProperties}
                >
                  {t({ id: 'web_invitebox_creer_compte' })}
                </span>
              </Link>
            </div>
          </div>

          <div className="w-[35%]">
            <Button onClick={() => pushRoute(urlLogin)} fullWidth color={'white'}>
              {t({ id: 'web_invitebox_boutton_login' })}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default InviteBox
